import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onModuleClick } from 'owa-left-rail-utils';
const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Addins" */ './lazyIndex'));
registerLazyOrchestrator(onModuleClick, lazyModule, m => m.moduleChangeOrchestrator);

export { default as initializeExtensibilityContext } from './initializeExtensibilityContext';
export { default as loadExtensibilityContext } from './loadExtensibilityContext';
